import React, { useState } from "react";
import {
  Card,
  Box,
  Typography,
  Chip,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  CardActionArea,
} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Link, useNavigate } from "react-router-dom";

interface YearCardProps {
  yearId: number;
  year: number;
  transactionCount: number;
  onEdit?: () => void;
  onDelete?: () => void;
}

export const YearCard: React.FC<YearCardProps> = ({
  year,
  yearId,
  onEdit,
  onDelete,
  transactionCount,
}) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(menuAnchorEl);
  const navigate = useNavigate();

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleDelete = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    handleMenuClose();
    if (onDelete) {
      onDelete();
    }
  };

  return (
    <Card
      elevation={3}
      className="tile"
      sx={{
        transition: "transform 0.2s, box-shadow 0.2s",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardActionArea
        onClick={() => navigate(`/transactions/${year}`)}
        style={{
          textDecoration: "none",
          // display: "flex",
          flexDirection: "column",
          flexGrow: 1,

          width: "100%",
        }}
      >
        <Box p={2} sx={{ flexGrow: 1 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={1}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <EventIcon color="primary" />
              <Typography variant="h2" color="primary">
                {year}
              </Typography>
            </Box>
          </Box>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="body1">
              Transactions: {transactionCount || 0}
            </Typography>
          </Box>

          <Box mt={2} display="flex" justifyContent="center">
            <Box
              sx={{
                height: 40,
                width: "100%",
                bgcolor: "rgba(0,0,0,0.04)",
                borderRadius: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="caption" color="text.secondary">
                View Details
              </Typography>
            </Box>
          </Box>
        </Box>
      </CardActionArea>
      {onDelete && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 1,
            borderTop: "1px solid rgba(0,0,0,0.08)",
          }}
        >
          <Tooltip title="Options">
            <IconButton size="small" color="inherit" onClick={handleMenuOpen}>
              <MoreVertIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      )}

      <Menu
        anchorEl={menuAnchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={handleDelete} sx={{ color: "error.main" }}>
          <DeleteIcon fontSize="small" sx={{ mr: 1 }} />
          Delete
        </MenuItem>
      </Menu>
    </Card>
  );
};

export default YearCard;
